<template>
  <div class="base-box">
    <van-field v-model="params.login" class="input-item" label="登录名" placeholder="包含字母、字数且不能是汉字"></van-field>
    <van-field v-model="params.name" class="input-item" label="单位名称" placeholder="请输入单位名称"></van-field>
    <!-- <van-cell
        class="input-item"
        title="会员类型"
        :value="memberName"
        is-link
        @click="setSelectModel('GROUP_TYPE','name','memberType')"
      /> -->
    <van-field class="input-item" :type="isShowPW ? 'password' : ''" label="密码"
      :right-icon="isShowPW ? 'closed-eye' : 'eye-o'" @click-right-icon="isShowPW = !isShowPW" v-model="params.password"
      placeholder="包含数字字符字母长度不小于8位"></van-field>
    <van-field class="input-item" :type="isShowPW2 ? 'password' : ''" label="确认密码"
      :right-icon="isShowPW2 ? 'closed-eye' : 'eye-o'" @click-right-icon="isShowPW2 = !isShowPW2"
      v-model="params.password2" placeholder="请再次输入您的登录密码"></van-field>
    <van-button class="successedBtn" type="primary" size="large" @click="submit">完成</van-button>
    <van-checkbox class="rule-box" checked-color="#1989fa" v-model="checked" icon-size="16px">
      我已阅读
      <span @click.stop="goHerf">《入会须知》</span>
    </van-checkbox>
    <el-dialog :visible.sync="show" title="入会须知" width="90%">
      <vanRule></vanRule>
    </el-dialog>
    <!-- 选择弹窗 -->
    <van-popup v-model="selectModel" position="bottom" :style="{ 'min-height': '20%' }">
      <template>
        <van-picker show-toolbar ref="picker" :value-key="key" :columns="columns" @change="onChange" @cancel="onCancel"
          @confirm="onConfirm" />
      </template>
    </van-popup>
  </div>
</template>

<script>
  import { Field, Button, Checkbox, Toast, Popup, Cell, Picker } from "vant";
  import { fastRegisterMember } from "@/api/login";
  import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
  import vanRule from "@/views/rule"
  export default {
    data() {
      return {
        params: {
          login: "",
          password: "",
          password2: "",
          memberCategory: 2,
          name: "",
          memberType: 1,
        },
        checked: false,
        isShowPW: true,
        isShowPW2: true,
        selectModel: false,
        memberName: "",
        key: "",
        columns: [],
        show: false
      };
    },
    components: {
      [Field.name]: Field,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [Popup.name]: Popup,
      [Cell.name]: Cell,
      [Picker.name]: Picker,
      vanRule
    },
    computed: {
      ...mapState(["memberTypeList"]),
      ...mapGetters(["GROUP_TYPE"]),
    },
    methods: {
      ...mapActions(["getMemberTypeList", "getDictionaryList"]),
      register() {
        let params = this.params;
        params.inviterId = sessionStorage.getItem("inviterId"),
          params.device = 'mobile'
        fastRegisterMember(params).then((res) => {
          if (res.success) {
            this.$emit("updateInfo", res.result);
            this.$emit("logInfo", params);
            // this.$emit("sendActive", 2);
          } else {
            if (res.messageCode == "110001") {
              Toast("用户名已经存在！");
              return;
            }
            Toast(res.message);
          }
        });
      },
      // goHerf(){
      //   window.open("http://www.forestry.gov.cn/hhxh/268/20150731/985923.html","_blank");
      // },
      goHerf() {
        this.show = true
        // this.$router.push({ path: "/rule" });
      },
      async submit() {
        let isChecked = this.$regexp.password(this.params.password),
          loginName = this.$regexp.loginOnly(this.params.login),
          regexpPassword = this.$regexp.chinese(this.params.password);

        if (!this.params.login) {
          Toast("请输入登录名!");
          return;
        }
        if (!loginName) {
          Toast("登录名只能是字母数字组合，不可纯数字或纯字母!");
          return;
        }
        if (!this.params.name) {
          Toast("请输入单位名称!");
          return;
        }
        if (!this.params.memberType) {
          Toast("请选择会员类型!");
          return;
        }
        if (!this.params.password || !isChecked || regexpPassword) {
          Toast("密码必须包含数字、字符、字母长度不小于8位!");
          return;
        }
        if (this.params.password !== this.params.password2) {
          Toast("两次输入的密码不正确!");
          return;
        }
        if (!this.checked) {
          Toast("请阅读入会须知！");
          return;
        }
        this.register();
      },
      setSelectModel(type, key, selectKey) {
        this.selectModel = true;
        this.key = key;
        this.selectKey = selectKey;
        this.columns = this[type];
      },
      onChange(picker, values, index) {
        this.changeData = values;
      },
      onConfirm(item) {
        this.selectModel = false;
        if (this.selectKey === "memberType") {
          this.params.memberType = item.value;
          this.memberName = item.name;
        } else if (this.selectKey === "add") {
          this.params.province = item[0].value;
          this.params.city = item[1] ? item[1].value : "";
          this.addName = item[0].name + item[1] ? item[1].name : "";
        } else {
          this.params[this.selectKey] = item.value;
        }
      },
      onCancel() {
        this.selectModel = false;
      },
    },
    mounted() {
      this.params.memberCategory = this.$route.query.memberCategory;
      //this.getMemberTypeList();
      this.getDictionaryList();
    },
  };
</script>

<style lang="less" scoped>
  /deep/.el-dialog__body {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 0 !important;
  }

  .input-item {
    padding: 0;
    padding-bottom: 12px;

    i {
      color: #aaa;
    }

    &+.input-item {
      margin-top: 20px;
    }
  }

  /deep/.van-field__label {
    width: 2.2rem
  }

  .successedBtn {
    margin: 30px 0 25px 0 !important;
  }

  .rule-box {
    justify-content: center;
    margin-bottom: 20px;
  }
</style>